import React from 'react';
import './CustomerService.css';

const CustomerService = () => {
  return (
    <section className="customer-service" id="customer-service">
      <div className="container service-container">
        <div className="service-image">
          <img src="/image/Service.jpg" alt="Luxury car top view" className="service-car-image" />
        </div>
        <div className="service-content">
          <h2 className="service-title">Superior Customer Service</h2>
          <p className="service-description">
            Our customer service team is available to assist with any inquiries regarding your car rental experience. We pride ourselves on our prompt, efficient and friendly service and will go above and beyond to ensure all of your expectations are exceeded.
          </p>
          <button className="service-btn">Learn more</button>
        </div>
      </div>
    </section>
  );
};

export default CustomerService; 